<div class="metadata-div">

  <span class="input-field-label" [matTooltip]="label ? label : ''" matTooltipPosition="above">
    <span *ngIf="visibility === 'MT_K'">*</span>{{label}}
  </span>

  <app-meta-data-onlyread *ngIf="visibility === 'MT_O'" [value]="humanvalue" [title]="label"></app-meta-data-onlyread>

  <mat-form-field *ngIf="visibility === 'MT_K' || visibility === 'MT_M'"
                  [color]="dateFormControl.invalid ? 'warn' : 'primary'">
    <input matInput [required]="visibility === 'MT_K'"
           [matDatepicker]="picker"
           [formControl]="dateFormControl"
           placeholder="YYYY. MM. DD."
           (dateChange)="formatNewValue($event.value)">
    <mat-datepicker-toggle matIconSuffix [for]="picker" class="calendar-button"></mat-datepicker-toggle>
    <mat-datepicker touchUi="true" #picker></mat-datepicker>
    <mat-error *ngIf="dateFormControl.hasError('required')">
      {{'MANDATORY_FIELD' | translate}}
    </mat-error>
  </mat-form-field>

</div>
